import { Table } from "antd";

import { DiscountCodeListProps } from "./types";
import { useDiscountCodeListColumns } from "./hooks";

const DiscountCodeList: React.FC<DiscountCodeListProps> = ({
  onDelete,
  ...props
}) => {
  const columns = useDiscountCodeListColumns({ onDelete });

  return <Table rowKey="id" {...{ columns, ...props }} />;
};

export default DiscountCodeList;
